import { render, staticRenderFns } from "./NotesAdmin.vue?vue&type=template&id=cc8b4ff0&scoped=true"
import script from "./NotesAdmin.vue?vue&type=script&lang=js"
export * from "./NotesAdmin.vue?vue&type=script&lang=js"
import style0 from "./NotesAdmin.vue?vue&type=style&index=0&id=cc8b4ff0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8b4ff0",
  null
  
)

export default component.exports